"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { EncryptionProvider } from "@/contexts/EncryptionContext";
import { SessionProvider } from "@/contexts/SessionContext";
import EncryptionModals from "@/components/encryption/EncryptionModals";
import { SessionTimeoutWarning } from "@/components/SessionTimeoutWarning";
export default function Providers(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [queryClient] = useState(_temp);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <EncryptionModals />;
    t2 = <SessionTimeoutWarning />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <SessionProvider><EncryptionProvider>{children}{t1}{t2}</EncryptionProvider></SessionProvider>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== queryClient || $[5] !== t3) {
    t4 = <QueryClientProvider client={queryClient}>{t3}</QueryClientProvider>;
    $[4] = queryClient;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
function _temp() {
  return new QueryClient();
}